import React from "react";
import { BackButtonProps } from "./back-button.type";
import * as SC from "./back-button.style";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowForward } from "@mui/icons-material";

export const BackButton = ({ children, to }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate(to);
  };

  return (
    <SC.BackButton>
      <Button onClick={handleNavigateBack} className="back-btn">
        <ArrowForward fontSize="medium" />
        {children}
      </Button>
    </SC.BackButton>
  );
};
